<template>
  <header class="sticky-top header">
    <div>
      <div class="logo">Broadleaf RFID Service WebConsole</div>
    </div>
    <div class="headerRightBlock" v-show="display">
      <div class="enterpriseName">{{ enterpriseName }}</div>
      <div class="enterpriseName">{{ userName }}</div>
      <div class="logout">
        <RfidButton :logoutPage=true @handleClick="logout">ログアウト</RfidButton>
      </div>
    </div>
  </header>
</template>

<script>
import RfidButton from '@/components/atoms/RfidButton'

export default {
  name: 'global-header',
  props: {
    display: false,
    enterpriseName: null,
    userName: null
  },

  methods: {
    logout () {
      this.$emit('logout')
    }
  },

  components: {
    RfidButton
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/partials/GlobalHeader.vue